

export const opts = [
  {
    name: "Standard Render v1",
    description: "Returns the merchant name at the left side and the case ID at the right side.",
    render: (contentPkg:any) => {
      return `
        <div className="w-full flex flex-row justify-between items-center gap-2">
          <span>{ ${contentPkg?.merchant} }</span>
          <span>Case No &mdash; { ${contentPkg?.case_id} }</span>
        </div>
      `
    }
  }
]